import Transaction from '../History/Transaction/Transaction';
import Warehouse from './Warehouse/Warehouse';

export function updateWarehouseNickname(
  currWarehouses: Warehouse[],
  warehouseIndex: number,
  newNickname: number | string | boolean | Transaction
) {
  if (typeof newNickname === 'string') {
    currWarehouses[warehouseIndex].nickname = newNickname;
  }

  return currWarehouses;
}
